import { Attribution, AttributionLink } from '@99designs/emu';
import { FormattedReactMessage, formatMessage } from '@99designs/frontend-components/i18n';
import { linkTo } from '@99designs/routing';

interface DesignerAttributionProps {
    text: string;
    userId?: string;
}

export function ContestDesignerAttribution({ text, userId }: DesignerAttributionProps) {
    if (userId) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('Winning design by <DesignerLink>{designerName}</DesignerLink>')}
                    values={{ designerName: text }}
                    replacements={{
                        DesignerLink: <AttributionLink href={linkTo.userProfile(userId)} />,
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('Winning design by {designerName}'), {
                designerName: text,
            })}
        </Attribution>
    );
}

export function DesignerAttribution({ text, userId }: DesignerAttributionProps) {
    if (userId) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('by <DesignerLink>{designerName}</DesignerLink>')}
                    values={{ designerName: text }}
                    replacements={{
                        DesignerLink: <AttributionLink href={linkTo.userProfile(userId)} />,
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('by {designerName}'), {
                designerName: text,
            })}
        </Attribution>
    );
}
